import React, { useState, useEffect } from "react";
import "../../styles/SubscriptionConfirmModal.css";
// Importe seus assets corretamente
import visaLogo from "../../assets/visa.png";
import mastercardLogo from "../../assets/mastercard.png";
import mercadoPagoLogo from "../../assets/mercado-pago.png";
import eloLogo from "../../assets/elo.png";
import { FaLock, FaHourglassHalf, FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

const SubscriptionConfirmModal = ({ 
  selectedPlan, 
  currentPlan, 
  onConfirm, 
  onClose, 
  isProcessing, 
  paymentStatus 
}) => {
  const [cardNumber, setCardNumber] = useState("");
  const [cardExpirationMonth, setCardExpirationMonth] = useState("");
  const [cardExpirationYear, setCardExpirationYear] = useState("");
  const [securityCode, setSecurityCode] = useState("");
  const [cardholderName, setCardholderName] = useState("");
  const [docNumber, setDocNumber] = useState("");
  const [cardType, setCardType] = useState(null);
  
  // Estado para controlar qual tela do modal mostrar
  const [modalState, setModalState] = useState("form"); // form, success, analysis, error

  // Deep Link do seu App (Ajuste conforme o scheme definido no React Native)
  // Exemplo: rondago://profile ou exp://... se for Expo Go
  const APP_SCHEME = "rondago://profile"; 
  const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.rondago.app"; // URL real se tiver
  const APP_STORE_URL = "https://apps.apple.com/app/id..."; // URL real se tiver

  useEffect(() => {
    if (paymentStatus === "approved") {
      setModalState("success");
    } else if (paymentStatus === "in_process") {
      setModalState("analysis");
    } else if (paymentStatus === "rejected") {
      setModalState("error");
    } else {
      setModalState("form");
    }
  }, [paymentStatus]);

  if (!selectedPlan) return null;

  const isUpgrade = currentPlan && selectedPlan.price > currentPlan.price;
  const isDowngrade = currentPlan && selectedPlan.price < currentPlan.price;
  const actionText = isUpgrade ? "Upgrade" : isDowngrade ? "Downgrade" : "Assinar";

  const detectCardType = (number) => {
    const visaRegex = /^4/;
    const mastercardRegex = /^5/;
    const eloRegex = /^6/;

    if (visaRegex.test(number)) setCardType(visaLogo);
    else if (mastercardRegex.test(number)) setCardType(mastercardLogo);
    else if (eloRegex.test(number)) setCardType(eloLogo);
    else setCardType(null);
  };

  const handleConfirm = () => {
    if (!cardNumber || !cardExpirationMonth || !cardExpirationYear || !securityCode || !cardholderName || !docNumber) {
      alert("⚠️ Preencha todos os campos do cartão.");
      return;
    }

    const cardData = {
      cardNumber: cardNumber.replace(/\s/g, ""), // Remove espaços
      cardExpirationMonth,
      cardExpirationYear,
      securityCode,
      cardholderName,
      docType: "CPF",
      docNumber: docNumber.replace(/\D/g, ""), // Remove pontuação
    };

    onConfirm(selectedPlan, cardData);
  };

  const handleDeepLink = () => {
    // Detecta se é dispositivo móvel
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      // Tenta abrir o App
      window.location.href = APP_SCHEME;

      // Opcional: Se não abrir em 2s, redireciona para loja (fallback)
      // setTimeout(() => {
      //   window.location.href = /Android/i.test(navigator.userAgent) ? PLAY_STORE_URL : APP_STORE_URL;
      // }, 2500);
    }
    
    // Fecha o modal no portal de qualquer jeito
    handleClose();
  };

  const handleClose = () => {
    setModalState("form"); // Reseta para o próximo uso
    onClose();
  };

  // --- RENDERIZAÇÃO CONDICIONAL (Só mostra UM modal por vez) ---

  // 1. Modal de Sucesso
  if (modalState === "success") {
    return (
      <div className="modal-overlay">
        <div className="modal-content success-content">
          <div className="icon-circle success">
            <FaCheckCircle size={50} />
          </div>
          <h3>Parabéns!</h3>
          <p>Sua assinatura do plano <strong>{selectedPlan.name}</strong> foi confirmada.</p>
          <button onClick={handleDeepLink} className="ok-button">
            Voltar para o App
          </button>
        </div>
      </div>
    );
  }

  // 2. Modal de Análise
  if (modalState === "analysis") {
    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="icon-circle warning">
            <FaHourglassHalf size={50} />
          </div>
          <h3>Pagamento em Análise</h3>
          <p>Recebemos seu pedido. Assim que o pagamento for confirmado, seu plano será ativado.</p>
          <button onClick={handleDeepLink} className="ok-button">
            OK, Entendi
          </button>
        </div>
      </div>
    );
  }

  // 3. Modal de Erro
  if (modalState === "error") {
    return (
      <div className="modal-overlay">
        <div className="modal-content error-content">
          <div className="icon-circle error">
            <FaExclamationTriangle size={50} />
          </div>
          <h3>Pagamento Recusado</h3>
          <p>Não foi possível processar seu cartão. Verifique os dados ou tente outro cartão.</p>
          <div className="modal-buttons center">
            <button onClick={() => setModalState("form")} className="retry-button">
              Tentar Novamente
            </button>
            <button onClick={handleClose} className="cancel-button-text">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    );
  }

  // 4. Modal de Formulário (Padrão)
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <FaLock size={20} color="#2274A5" />
          <h3>Confirmação de {actionText}</h3>
          <img src={mercadoPagoLogo} alt="Mercado Pago" className="mercado-pago-logo" />
        </div>

        <p className="plan-summary">
            Plano selecionado: <strong>{selectedPlan.name}</strong> <br/>
            Valor: <strong>R$ {selectedPlan.price.toFixed(2).replace('.', ',')}</strong>
        </p>

        {/* Ícones das bandeiras */}
        <div className="payment-methods">
          <img src={visaLogo} alt="Visa" className={cardType === visaLogo ? "selected" : ""} />
          <img src={mastercardLogo} alt="Mastercard" className={cardType === mastercardLogo ? "selected" : ""} />
          <img src={eloLogo} alt="Elo" className={cardType === eloLogo ? "selected" : ""} />
        </div>

        <div className="input-group">
            <input 
              type="text" 
              className="card-input"
              placeholder="Número do Cartão" 
              value={cardNumber} 
              maxLength={19}
              onChange={(e) => { 
                // Formata com espaços a cada 4 dígitos
                const v = e.target.value.replace(/\D/g, '').substring(0,16);
                const formatted = v.match(/.{1,4}/g)?.join(' ') || v;
                setCardNumber(formatted); 
                detectCardType(v); 
              }} 
            />
            {cardType && <img src={cardType} alt="Bandeira" className="card-input-icon" />}
        </div>

        <div className="expiration-fields">
          <select value={cardExpirationMonth} onChange={(e) => setCardExpirationMonth(e.target.value)}>
            <option value="">Mês</option>
            {[...Array(12)].map((_, i) => (
              <option key={i + 1} value={String(i + 1).padStart(2, '0')}>{String(i + 1).padStart(2, '0')}</option>
            ))}
          </select>
          <select value={cardExpirationYear} onChange={(e) => setCardExpirationYear(e.target.value)}>
            <option value="">Ano</option>
            {[...Array(15)].map((_, i) => ( // Aumentei para 15 anos
              <option key={i} value={2025 + i}>{2025 + i}</option>
            ))}
          </select>
        </div>

        <div className="expiration-fields">
            <input 
                type="text" 
                placeholder="CVV" 
                maxLength={4}
                style={{ width: '48%' }}
                onChange={(e) => setSecurityCode(e.target.value.replace(/\D/g, ''))} 
            />
            <input 
                type="text" 
                placeholder="CPF do Titular" 
                maxLength={14}
                style={{ width: '48%' }}
                value={docNumber}
                onChange={(e) => setDocNumber(e.target.value)} 
            />
        </div>
        
        <input 
            type="text" 
            placeholder="Nome impresso no Cartão" 
            style={{ textTransform: 'uppercase' }}
            onChange={(e) => setCardholderName(e.target.value)} 
        />

        {isProcessing && (
          <div className="processing-overlay">
            <FaHourglassHalf className="loading-icon spin" />
            <p>Processando pagamento seguro...</p>
          </div>
        )}

        <div className="modal-buttons">
          <button className="cancel-button" onClick={onClose} disabled={isProcessing}>
            Cancelar
          </button>
          <button 
            className="confirm-button" 
            onClick={handleConfirm} 
            disabled={isProcessing}
          >
            {isProcessing ? "Aguarde..." : `Pagar e Assinar`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionConfirmModal;